import React from 'react';

import CallToActionSection from './CallToActionSection';
import FooterSection from './FooterSection';

const Layout_Without_Testimony = () => {
  return (
    <div className="footer_automatic_files">
      <div className="layout_main_section">
        
      <div  className="layout_testimonial_section">
          &nbsp;
         
        </div>

        <div  className="layout_call_to_action_section">
          <CallToActionSection />
        </div>
        <div  className="layout_footer_section">
          <FooterSection />
        </div>
      </div>
    </div>
  );
};

export default Layout_Without_Testimony;

